import http from "./http_common";

class MemberShipService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
      .join("&");
  }
  getMemberShipDetails() {
    return http.get(`/MembershipMaster/list`);
  }
  savePatientPlanDetails(payload) {
    // var queryString = this.queryString(payload);
    return http.post(`PatientMembership/save`, payload);
  }

  getPatientMembershipDetails(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/PatientMembership/list/filter?${queryString}`);
  }

  getMemberShipDetailsByCode(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/MembershipServiceDetails/list?${queryString}`);
  }

  getMembershipPlans(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/MembershipMaster/list?${queryString}`);
  }

  getMembershipDetails(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/MembershipServiceDetails/list?${queryString}`);
  }

  getMemberships(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/PatientMembership/list/filter?${queryString}`);
  }
}

export default new MemberShipService();
